//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['categorias', 'contexto'],
  data() {
    return {
      selectCategoria: '',
    }
  },
  watch: {
    $route(to, from) {
      this.selectCategoria = to.params.slug
    },
  },
  mounted() {
    this.selectCategoria = this.$route.params.slug
  },
}
